import React, { useEffect, useState } from "react";
import MSwitch from "../common/switch";

/**
 * {value: boolean}
 */
const BoolInput = ({ valueSpec, onChange }) => {
  const [value, setValue] = useState(false);
  const isReadOnly = valueSpec?.readOnly;

  useEffect(() => {
    setValue(valueSpec.value || false);
    return () => {};
  }, [valueSpec]);

  const handleChange = (event) => {
    if (!event || isReadOnly) return;
    setValue(event.target.checked);
    onChange(event.target.checked.toString());
  };

  return (
    <div className="flex items-center relative w-full">
      <div className="w-full flex justify-center">
        <MSwitch
          checked={value}
          onChange={handleChange}
          disabled={isReadOnly}
          inputProps={{ "aria-label": "controlled" }}
        />
      </div>
    </div>
  );
};

export default BoolInput;
